import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Switch from "react-switch";
import menu_icon from "../images/icons-menu.png";
import close_icon from "../images/icons-close.png";
import menu_icon_white from "../images/icons-menu-white.png";
import close_icon_white from "../images/icons-close-white.png";
import icon_sun from "../images/icons-sun.png";
import icon_moon from "../images/icons-moon.png";
import icon_hindi from "../images/icon_hindi.png";
import icon_english from "../images/icon_english.png";
import "../styles/App.css";

const Navbar = () => {
  let themVal = localStorage.getItem("theme");
  let theme = themVal ? themVal : "light";

  const currentLanguageVal = localStorage.getItem("language");
  const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";

  const [isOpen, setIsOpen] = useState(false);
  const [checked, setChecked] = useState(theme === "light" ? true : false);
  const [language, setLanguage] = useState({
    language: "english",
    id: "english",
  });

  useEffect(() => {
    if (theme === "dark") {
      setChecked(false);
      document.querySelector("body").setAttribute("data-theme", "dark");
    } else {
      setChecked(true);
      document.querySelector("body").setAttribute("data-theme", "light");
    }
  }, []);

  useEffect(() => {
    if (currentLanguage === "hi") {
      setLanguage({ language: "hi", id: "hindi" });
    } else {
      setLanguage({ language: "en", id: "english" });
    }
  }, []);

  const handleChange = (nextChecked) => {
    if (nextChecked === true) {
      localStorage.setItem("theme", "light");
      document.querySelector("body").setAttribute("data-theme", "light");
    } else {
      localStorage.setItem("theme", "dark");
      document.querySelector("body").setAttribute("data-theme", "dark");
    }
    setChecked(nextChecked);
  };
  const handleLanguageChange = (e) => {
    let id = e.target.id;
    if (id === "english") {
      setLanguage({ language: "hi", id: "hindi" });
      localStorage.setItem("language", "hi");
      document.querySelector("body").setAttribute("lang", "hi");
      window.location.reload();
    } else {
      setLanguage({ language: "en", id: "english" });
      localStorage.setItem("language", "en");
      document.querySelector("body").setAttribute("lang", "en");
      window.location.reload();
    }
  };
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (!isOpen && window.innerWidth <= 500) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "scroll";
    }
  };

  const translateNavItems = (item) => {
    const translations = {
      home: { en: "Home", hi: "होम" },
      ideals: { en: "Ideals", hi: "आदर्श" },
      gurus: { en: "Lineage", hi: "गुरु परंपरा" },
      publications: { en: "Publications", hi: "प्रकाशन" },
      events: { en: "Events", hi: "कार्यक्रम" },
      branches: { en: "Branches", hi: "शाखाएँ" },
      gallery: { en: "Gallery", hi: "गैलरी" },
    };
    return translations[item][currentLanguage];
  };

  return (
    <nav className="navbar">
      <div className="menu-toggle" onClick={toggleMenu}>
        {isOpen ? (
          <img
            className="navbar-icons"
            src={theme === "light" ? close_icon : close_icon_white}
            alt="Close menu"
            height="40"
            width="auto"
          />
        ) : (
          <img
            className="navbar-icons"
            src={theme === "light" ? menu_icon : menu_icon_white}
            alt="Open menu"
            height="40"
            width="auto"
          />
        )}
      </div>
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li id="home" onClick={toggleMenu}>
          <Link
            to="/"
            className={location.pathname === "/" ? "active-link" : ""}
          >
            {translateNavItems("home")}
          </Link>
        </li>
        <li id="ideals" onClick={toggleMenu}>
          <Link
            to="/ideals"
            className={location.pathname === "/ideals" ? "active-link" : ""}
          >
            {translateNavItems("ideals")}
          </Link>
        </li>
        <li id="gurus" onClick={toggleMenu}>
          <Link
            to="/gurus"
            className={
              location.pathname.includes("/gurus") ? "active-link" : ""
            }
          >
            {translateNavItems("gurus")}
          </Link>
        </li>
        <li id="publications" onClick={toggleMenu}>
          <Link
            to="/publications"
            className={
              location.pathname === "/publications" ? "active-link" : ""
            }
          >
            {translateNavItems("publications")}
          </Link>
        </li>
        <li id="events" onClick={toggleMenu}>
          <Link
            to="/events/holi"
            className={location.pathname.includes("/events") ? "active-link" : ""}
          >
            {translateNavItems("events")}
          </Link>
        </li>
        <li id="branches" onClick={toggleMenu}>
          <Link
            to="/branches"
            className={location.pathname === "/branches" ? "active-link" : ""}
          >
            {translateNavItems("branches")}
          </Link>
        </li>
        <li id="gallery" onClick={toggleMenu}>
          <Link
            to="/gallery"
            className={location.pathname === "/gallery" ? "active-link" : ""}
          >
            {translateNavItems("gallery")}
          </Link>
        </li>
      </ul>
      <div className="navbar-utility">
        <Switch
          onChange={handleChange}
          checked={checked}
          className="react-switch"
          offColor="#666"
          onColor="#f39c12"
          checkedIcon={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <img
                src={icon_sun}
                alt="Sun icon"
                style={{ width: "20px", height: "20px" }}
              />
            </div>
          }
          uncheckedIcon={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <img
                src={icon_moon}
                alt="Moon icon"
                style={{ width: "20px", height: "20px" }}
              />
            </div>
          }
        />
        <button className="language-button" onClick={handleLanguageChange}>
          <img
            src={language.language === "en" ? icon_hindi : icon_english}
            alt="Language text"
            className="language-icon"
            id={language.id}
            height={language.language === "en" ? "24px" : "16px"}
          />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
